<script>
export default {
    name: "OrderInfoBanner"
}
</script>

<template>
    <div class="order-info-banner-wrapper">
        <div class="order-info-banner">
            <ul>
                <li><span>Bénéficiaire :</span> <span>Testachats</span></li>
                <li><span>Prix total :</span> <span>2,00 €</span></li>
            </ul>
        </div>
    </div>
</template>

<style scoped>

</style>
